/**
 * The living expenses a scenario runs on (owner, 9 Oct 2026).
 *
 * The aged care screen asks what the household spends once care begins. An adviser may enter $0 —
 * the resident's needs are met by the home and there is no one else to keep — and that is a real
 * answer, not a blank. The year-by-year projection always honoured it; the first-year assessment,
 * the Suggestion Engine's candidates and several screens read it with `||`, so $0 fell back to the
 * profile's figure. Bob's walk-in projection ran on $0 while every card around it ran on $25,000,
 * and the two estates differed by $107,733.
 *
 * One rule now: a figure that was ENTERED — any finite number, $0 included — is used; only a blank
 * (undefined, null, empty text) falls back to the fact-find's living expenses.
 */
export function enteredAmount(value: unknown): number | null {
    if (value === undefined || value === null) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    const n = typeof value === 'number' ? value : Number(String(value).replace(/[$,\s]/g, ''));
    return Number.isFinite(n) ? Math.max(0, n) : null;
}

export function scenarioLivingExpensesOr(scenario: unknown, fallback: unknown): number {
    const entered = enteredAmount(scenario);
    if (entered != null) return entered;
    return enteredAmount(fallback) ?? 0;
}
